<template>
  <v-row class="ma-0 white device_details">
    <v-col cols="12" class="pa-0">
      <v-row no-gutters>
        <v-col cols="12" class="border-bottom">
          <v-row no-gutters class="font-weight-bold pt-3 px-4">
            <v-col cols="12">
              {{ device_data.DeviceName }}/{{ device_data.SerialNumber }}/{{ device_data.PowerRating }}/{{
                device_data.AssetID
              }}
              -
              {{ deviceId || $route.params.deviceId }}
            </v-col>
            <v-col cols="12">
              <div v-if="device_data.CurrentLat" class="d-flex mt-1 text-caption primaryGrey--text">
                <div><v-icon class="mr-1" color="primary" small>mdi-latitude</v-icon>{{ device_data.CurrentLat }}</div>
                <div class="ml-3">
                  <v-icon class="mr-1" color="primary" small>mdi-longitude</v-icon>{{ device_data.CurrentLng }}
                </div>
              </div>
            </v-col>
          </v-row>
          <v-row no-gutters class="mt-3">
            <v-col cols="4" class="pl-4 mb-3" v-for="(data, index) in page_content.device_details" :key="index">
              <div style="font-size: 14px; font-weight: bold">
                {{ data.label }}
              </div>
              <v-icon small v-if="data.icon">{{ data.icon }}</v-icon>
              <span class="primaryDark--text" v-if="data.type == 'datetime'">{{ device_data[data.value] | date }}</span>
              <span class="primaryDark--text" v-if="data.type == 'date'">{{
                $dateFormat(device_data[data.value])
              }}</span>
              <span class="primaryDark--text" v-else>
                {{ device_data[data.value] }}
              </span>
              <span v-if="data.suffix && device_data[data.value]">{{ data.suffix }}</span>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" v-if="journeys_list || messages_list">
          <div class="primaryDark--text">
            <div class="mt-3" style="margin-bottom: 40px">
              <div v-for="(chart, index) in page_content.chart_config" :key="`chart_${index}`">
                <div class="primary--text text-subtitle-2 px-4">
                  {{ chart.label }}
                </div>
                <ComboChartVT
                  :chartData="chart_data[index]"
                  :ylabel="chart.yAxis"
                  :xlabel="chart.xAxis"
                  lineWidth="0.6"
                  pointSize="0.6"
                  dataOpacity="1"
                  :colors="chart.colors"
                ></ComboChartVT>
              </div>
            </div>
            <DataTableVT
              :headers="page_content.messages_table_snapshot"
              :items_list="messages_list"
              :no_search="no_search"
              no_pagination="true"
              print="true"
              no_sort="true"
            />
          </div>
        </v-col>
      </v-row>
      <v-container></v-container>
    </v-col>
  </v-row>
</template>

<script>
import axios from "axios";
import DataTableVT from "../components/DataTableVT";
import ComboChartVT from "../components/ComboChartVT";
import { content } from "../../config/assets.js";
import { axios_get } from "../services/vt_service";
import { trafo } from "../services/powerdata";

const tenant_key = process.env["VUE_APP_TENANT_KEY"];
const api_root = process.env["VUE_APP_ROOT_API"];

export default {
  props: ["deviceId"],
  watch: {
    deviceId: function () {
      this.get_device_data();
      this.get_device_list();
    },
  },
  name: "AssetSnapshot",
  components: {
    DataTableVT,
    ComboChartVT,
  },
  data: function () {
    return {
      flat: true,
      no_search: true,
      network_error: false,
      page_content: null,
      journeys_list: null,
      stats_data: null,
      messages_list: null,
      device_data: {},
      has_coordinates: false,
      chartData: [],
      device_id: "",
      location_data: {},
      show_info_window: true,
      show_map_object: null,
      duration: null,
      chartOptions: {
        chart: {
          title: "Device Signals",
          subtitle: "Messages received (last 7 days)",
        },
      },
    };
  },
  created() {
    this.page_content = content;
    this.duration = this.page_content.chart_select[0];
  },
  mounted() {
    this.device_id = this.$route.params.deviceId;
    this.get_device_data();
    this.get_device_list();
  },
  methods: {
    show_location_on_map(obj) {
      this.show_map_object = obj[1];
    },
    get_missing_count(data) {
      var prev_seq = null;
      var count_missing = 0;
      for (var i = 0; i < data.length; i++) {
        count_missing = 0;
        if (prev_seq != null) {
          count_missing = prev_seq - ((data[i].SeqNo + 1) % 4096);
        }
        prev_seq = data[i].SeqNo;
        if (i > 0) {
          data[i - 1]["CountMissing"] = count_missing;
        }
      }
      data[data.length - 1]["CountMissing"] = 0;
      return data;
    },
    async get_device_data() {
      //this.$store.commit("show_loader");
      const accessToken = await this.$auth.getTokenSilently();
      this.network_error = false;
      var self = this;
      const tenant = this.$auth.user[tenant_key]["tenant"];
      if (this.$route.params && this.$route.params.deviceId) {
        this.no_search = false;
        this.device_id = this.$route.params.deviceId;
        this.$store.commit("clear_search");
        this.$store.commit("update_page_title", `Device / ${this.device_id}`);
      } else {
        this.device_id = this.deviceId;
      }
      let header = {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          Tenant: tenant,
        },
      };
      let get_stats = axios.get(api_root + "/api/powerdata/device/chartdata/" + this.device_id, header);
      let get_messages = axios.get(api_root + "/api/powerdata/messages/device/" + this.device_id, header);
      axios
        .all([get_stats, get_messages])
        .then(
          axios.spread((...responses) => {
            self.stats_data = responses[0].data;
            // self.messages_list = responses[1].data;
            self.messages_list = this.get_missing_count(responses[1].data);
          })
        )
        .catch((e) => {
          self.network_error = true;
          console.log(e);
        });
    },
    async get_device_list() {
      this.network_error = false;
      let response = await axios_get(trafo.get_assets_data, { num_days: 1 });
      this.device_data = response.filter((elem) => elem.DeviceID == this.device_id)[0];
    },
  },
  computed: {
    chart_data() {
      let temprature_temp = [["Timestamp", "Temperature Med", "Temperature Max"]];
      let current0_temp = [["Timestamp", "Current PH1 Med", "Current PH1 Max"]];
      let current1_temp = [["Timestamp", "Current PH2 Med", "Current PH2 Max"]];
      let current2_temp = [["Timestamp", "Current PH3 Med", "Current PH3 Max"]];
      let consolidated_im_medc = [["Timestamp", "Imbalance", "Current PH1 Med", "Current PH2 Med", "Current PH3 Med"]];
      let consolidated_tp_medc = [
        ["Timestamp", "Total Power", "Current PH1 Med", "Current PH2 Med", "Current PH3 Med"],
      ];
      let consolidated_im_maxc = [["Timestamp", "Imbalance", "Current PH1 Max", "Current PH2 Max", "Current PH3 Max"]];
      let consolidated_tp_maxc = [
        ["Timestamp", "Total Power", "Current PH1 Max", "Current PH2 Max", "Current PH3 Max"],
      ];
      let total_temp = [["Timestamp", "Total Power"]];
      let imbalance_temp = [["Timestamp", "Imbalance"]];

      var start_date = new Date();
      start_date.setDate(start_date.getDate() - this.duration.value);

      for (let i = 0; i < this.stats_data["Timestamp"].length; i++) {
        let timestmp = new Date(this.stats_data["Timestamp"][i]);
        if (start_date > timestmp) {
          break;
        }

        temprature_temp.push([
          timestmp,
          this.stats_data["TemperatureMed"] && this.stats_data["TemperatureMed"][i],
          this.stats_data["TemperatureMed"] && this.stats_data["TemperatureMed"][i],
        ]);
        current0_temp.push([timestmp, this.stats_data["Current0Med"][i], this.stats_data["Current0Max"][i]]);
        current1_temp.push([timestmp, this.stats_data["Current1Med"][i], this.stats_data["Current1Max"][i]]);
        current2_temp.push([timestmp, this.stats_data["Current2Med"][i], this.stats_data["Current2Max"][i]]);
        total_temp.push([timestmp, this.stats_data["TotalPower"][i]]);
        imbalance_temp.push([timestmp, this.stats_data["Imbalance"][i]]);
        consolidated_im_medc.push([
          timestmp,
          this.stats_data["Imbalance"][i],
          this.stats_data["Current0Med"][i],
          this.stats_data["Current1Med"][i],
          this.stats_data["Current2Med"][i],
        ]);
        consolidated_tp_medc.push([
          timestmp,
          this.stats_data["TotalPower"][i],
          this.stats_data["Current0Med"][i],
          this.stats_data["Current1Med"][i],
          this.stats_data["Current2Med"][i],
        ]);
        consolidated_im_maxc.push([
          timestmp,
          this.stats_data["Imbalance"][i],
          this.stats_data["Current0Max"][i],
          this.stats_data["Current1Max"][i],
          this.stats_data["Current2Max"][i],
        ]);
        consolidated_tp_maxc.push([
          timestmp,
          this.stats_data["TotalPower"][i],
          this.stats_data["Current0Max"][i],
          this.stats_data["Current1Max"][i],
          this.stats_data["Current2Max"][i],
        ]);
      }
      return this.stats_data
        ? [temprature_temp, consolidated_im_medc, consolidated_tp_medc, consolidated_im_maxc, consolidated_tp_maxc]
        : null;
    },
    computed_location_details() {
      let temp_obj = JSON.parse(JSON.stringify(this.device_data));
      if (this.location_data) {
        let current_location = this.location_data[this.device_data.CurrentPOI];
        if (current_location) {
          temp_obj["LocationID"] = current_location["LocationID"];
          temp_obj["FlowRate"] = current_location["FlowRate"];
          temp_obj["FluidAssets"] = current_location["FluidAssets"];
          temp_obj["FullName"] = current_location["FullName"];
          temp_obj["StaticAssets"] = current_location["StaticAssets"];
          temp_obj["TotalAssets"] = current_location["TotalAssets"];
          temp_obj["Utilisation"] = current_location["Utilisation"];
          temp_obj["LocationCategory"] = current_location["LocationCategory"];
        }
      }
      return temp_obj;
    },
    map_data: function () {
      return this.computed_location_details.CurrentLat ? [this.computed_location_details] : [];
    },
    get_center: function () {
      return this.map_data
        ? new window.google.maps.LatLng(
            this.computed_location_details.CurrentLat,
            this.computed_location_details.CurrentLng
          )
        : null;
    },
  },
};
</script>

<style lang="scss" scoped>
.device_details .title {
  font-size: 0.75rem !important;
  font-family: Trade Gothic Regular !important;
}
.border-bottom {
  border-bottom: 1px solid var(--v-restingOutline-base);
}
.duration_select_div {
  .duration_select {
    width: 9em;
    margin-right: 1em;
    margin-left: auto;
  }
}
::v-deep .export-div {
  top: 25px;
  right: 2rem;
}
</style>
